import { getCvSearchResults, buyCV } from "../webservices/cvSearchWS";
import { fetchItemsWS } from "../webservices/fetchWS";
import { createItemWs, updateItemWs } from "../webservices/saveWS";
import { createTenantWalletWs, createWalletTenantWs } from "../webservices/walletWS";
// import { fetchSectionsAction, fetchQuestionsAction, fetchLookupsAction } from "./activationRulesActions";
import { CVSearchlogDTO } from "./DTOs/CVSearchlogDTO";
import { UserDTO } from "./DTOs/UserDTO";
import { SAVE_IN_PROGRESS, SAVE_PROCESS_DONE } from "./fetchingDataActions";
import _ from "lodash";
import { toast } from "react-toastify";
import { FETCH_LOOKUPS_SUCCESS_ACTION, FETCH_LOOKUPS_ERROR_ACTION } from "./lookupsActions";

export const fetchSkillsQnaire = tenant => {
    return async (dispatch, getState) => {
        const qnaireParams = {
            GSI2PK: `2WWjarbwyZ6IvJpoQKfzVWkGWiK%23QNAIRES`,
            GSI2SK: 'QNAIRE%23',
        };

        try {
            dispatch({ type: SAVE_IN_PROGRESS });
            const qnaires = await fetchItemsWS('get-dynamodb', qnaireParams, getState);
            const SkillsQnaireDetails = qnaires.Items.filter(item => item.op !== 'd' && item.isBaseQnaire === true && item.isActive === true && item.questionaireType === 'My Skills and Work Experience');

            await fetchSectionsAction(SkillsQnaireDetails[0].id, SkillsQnaireDetails[0].tenantId)(dispatch, getState);
            const skillsQuestions = await fetchQuestionsAction(SkillsQnaireDetails[0].id, SkillsQnaireDetails[0].tenantId)(dispatch, getState);

            await fetchQuestionLookups(skillsQuestions, SkillsQnaireDetails[0].tenantId)(dispatch, getState);

        } catch (err) {
            toast.error("There was an error fetching lookup questions. Please try again later.");
            dispatch({ type: SAVE_PROCESS_DONE });
            throw err;
        }
    };
}

export const FETCHING_SKILLS_QUESTIONS_ACTION = "FETCHING_SKILLS_QUESTIONS_ACTION";
export const FETCH_SKILLS_QUESTIONS_SUCCESS_ACTION = "FETCH_SKILLS_QUESTIONS_SUCCESS_ACTION";
export const FETCH_SKILLS_QUESTIONS_ERROR_ACTION = "FETCH_SKILLS_QUESTIONS_ERROR_ACTION";

export const fetchQuestionsAction = (questionaireId, tenantId) => {
    const queryParams = {
        PK: `${tenantId}%23QNAIRE%23${questionaireId}`,
        SK: 'QUESTION%23',
    };

    return (dispatch, getState) => {
        return fetchItemsWS('get-dynamodb', queryParams, getState)
            .then((result) => {
                const returnItems = result.Items.filter(item => item.status !== "isDeleted");
                dispatch({
                    type: FETCH_SKILLS_QUESTIONS_SUCCESS_ACTION,
                    payload: returnItems,
                });
                return returnItems;
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: FETCH_SKILLS_QUESTIONS_ERROR_ACTION, err });
                throw err;
            });
    };
};

export const FETCHING_SKILLS_SECTIONS_ACTION = "FETCHING_SKILLS_SECTIONS_ACTION";
export const FETCH_SKILLS_SECTIONS_SUCCESS_ACTION = "FETCH_SKILLS_SECTIONS_SUCCESS_ACTION";
export const FETCH_SKILLS_SECTIONS_ERROR_ACTION = "FETCH_SKILLS_SECTIONS_ERROR_ACTION";

export const fetchSectionsAction = (questionaireId, tenantId) => {
    const queryParams = {
        PK: `${tenantId}%23QNAIRE%23${questionaireId}`,
        SK: 'SECTION%23',
    };

    return (dispatch, getState) => {
        fetchItemsWS('get-dynamodb', queryParams, getState)
            .then((result) => {
                const returnItems = result.Items.filter(item => item.status !== "isDeleted");
                dispatch({
                    type: FETCH_SKILLS_SECTIONS_SUCCESS_ACTION,
                    payload: returnItems,
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: FETCH_SKILLS_SECTIONS_ERROR_ACTION, err });
            });
    };
};

export const FETCHING_SKILLS_QUESTION_LOOKUP_ACTION = 'FETCHING_SKILLS_QUESTION_LOOKUP_ACTION';
export const FETCH_SKILLS_QUESTION_LOOKUP_SUCCESS_ACTION = 'FETCH_SKILLS_QUESTION_LOOKUP_SUCCESS_ACTION';
export const FETCH_SKILLS_QUESTION_LOOKUP_ERROR_ACTION = 'FETCH_SKILLS_QUESTION_LOOKUP_ERROR_ACTION';

export const fetchQuestionLookups = (questions, tenantId) => {
    return async (dispatch, getState) => {
        dispatch({ type: FETCHING_SKILLS_QUESTION_LOOKUP_ACTION });

        // Get unique lookup IDs from questions that have lookups
        const lookupIds = [...new Set(
            questions
                .filter(question => question.lookupId)
                .map(question => question.lookupId)
        )];

        if (lookupIds.length === 0) {
            dispatch({ type: FETCH_LOOKUPS_SUCCESS_ACTION, payload: [] });
            return;
        }

        try {
            const lookupPromises = lookupIds.map(lookupId => {
                const queryParams = {
                    PK: `${tenantId}%23LOOKUPS`,
                    SK: `LOOKUP%23${lookupId}`,
                };
                return fetchItemsWS('get-dynamodb', queryParams, getState);
            });

            const results = await Promise.all(lookupPromises);
            const allLookups = results.flatMap(result =>
                result.Items.filter(item => item.op !== 'd')
            );

            dispatch({ type: FETCH_LOOKUPS_SUCCESS_ACTION, payload: allLookups });
        } catch (err) {
            toast.error("There was an error fetching the lookups for this questions. Please try again later.");
            dispatch({ type: FETCH_LOOKUPS_ERROR_ACTION, err });
        }
    }
}

export const CV_SEARCH_ACTION = "CV_SEARCH_ACTION";

export const cvSearchAction = (payload, tenant, setLoading) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: SAVE_IN_PROGRESS });
            setLoading(true);
            const result = await getCvSearchResults(payload, getState);
            dispatch({ type: CV_SEARCH_ACTION, payload: result.data });
            setLoading(false);
            if (_.isEmpty(result.data.data)) {
                toast.error("We are unable to find any results to match your requirements. Please try again.");
            }
            return logCVSearchAction(payload, tenant, result.data)(dispatch, getState);
        } catch (err) {
            toast.error("There was an error performing the search.  Please try again later.");
            dispatch({ type: SAVE_PROCESS_DONE });
            setLoading(false);
            throw err;
        }
    };
};

export const logCVSearchAction = (payload, tenant, resultData) => {
    return (dispatch, getState) => {
        const cvLog = new CVSearchlogDTO(payload, tenant, resultData);
        createItemWs(cvLog, getState)
            .then((result) => {
                return result.data
            })
            .catch((err) => {
                dispatch({ type: SAVE_PROCESS_DONE });
                throw err;
            })
    }
}
////////////////////////////////////////////////////////////////////////////////////////
//CV Purchasing Actions
export const purchaseCVAction = (cv, cvSearchQuery, setLoading) => {

    let matchPercentage = Math.round(((cv._score - 0) / (1 - 0)) * 100 / 5) * 5;

    matchPercentage = Math.min(Math.max(0, matchPercentage), 100);

    return async (dispatch, getState) => {
        let payload = {
            userId: cv._source.userid,
            qnaireId: cv._source.questionaireid,
            cvSearchQuery: cvSearchQuery,
            matchPercentage: matchPercentage,
        }
        try {
            setLoading(true);
            const result = await buyCV(payload, getState);
            if (result === 404) {
                return getUserDetails(cv, setLoading, dispatch, getState);
            }
            setLoading(false);
            toast.success("Successfully purchased cv!");
        } catch (err) {
            console.log(err);
            toast.error("There was an error purchasing the cv. Please try again later.");
            dispatch({ type: SAVE_PROCESS_DONE });
            setLoading(false);
        }
    }
}

export const getUserDetails = async (cv, setLoading, dispatch, getState) => {
    const queryParams = {
        PK: `USERS`,
        SK: `USER%23${cv._source.userid}`,
    };

    try {
        const result = await fetchItemsWS('get-dynamodb', queryParams, getState);
        const user = result.Items.filter(item => item.status !== "isDeleted");
        return createWalletUserAction(user[0], cv, setLoading)(dispatch, getState);
    } catch (err) {
        setLoading(false);
        console.log(err);
        throw err;
    }
}

export const createWalletUserAction = (user, cv, setLoading) => {
    let data = {
        phoneNumber: user.id,
    }
    return (dispatch, getState) => {
        dispatch({ type: SAVE_IN_PROGRESS });
        createWalletTenantWs(data, getState)
            .then((result) => {
                const userData = result.data;
                return createUserWalletAction(userData, user, cv, setLoading)(dispatch, getState);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
                dispatch({ type: SAVE_PROCESS_DONE });
            });
    }
}

export const createUserWalletAction = (userData, user, cv, setLoading) => {
    return (dispatch, getState) => {
        let data = {
            userId: userData.user_id,
        }
        dispatch({ type: SAVE_IN_PROGRESS });
        createTenantWalletWs(data, getState)
            .then((result) => {
                const walletData = result.data;

                const newUserData = {
                    PK: user.PK,
                    SK: user.SK,
                    id: user.id,
                    contact_nr: user.id,
                    walletUserId: walletData.user_id,
                    walletId: walletData.wallet_id,
                };

                const newTenant = new UserDTO(newUserData);
                updateItemWs(newTenant, getState)
                    .then((result) => {
                        return purchaseCVAction(cv, setLoading)(dispatch, getState);
                    })
                    .catch((err) => {
                        console.log(err);
                        dispatch({ type: SAVE_PROCESS_DONE });
                    });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: SAVE_PROCESS_DONE });
            });
    }
}
////////////////////////////////////////////////////////////////////////////////////////
//View Selected CV actions
export const FETCHING_SELECTED_CV_ACTION = 'FETCHING_SELECTED_CV_ACTION';
export const FETCH_SELECTED_CV_ANSWERS_SUCCESS_ACTION = 'FETCH_SELECTED_CV_ANSWERS_SUCCESS_ACTION';
export const FETCH_SELECTED_CV_QNAIRE_SUCCESS_ACTION = 'FETCH_SELECTED_CV_QNAIRE_SUCCESS_ACTION';
export const FETCH_SELECTED_CV_ERROR_ACTION = 'FETCH_SELECTED_CV_ERROR_ACTION';

export const fetchSelectedCVAction = (cv, tenant, setLoading) => {
    return async (dispatch, getState) => {
        setLoading(true);
        dispatch({ type: FETCHING_SELECTED_CV_ACTION });

        try {
            // Fetch base qnaires to find the active My Skills questionnaire
            const qnaireListParams = {
                GSI2PK: `2WWjarbwyZ6IvJpoQKfzVWkGWiK%23QNAIRES`,
                GSI2SK: 'QNAIRE%23',
            };
            const qnairesResult = await fetchItemsWS('get-dynamodb', qnaireListParams, getState);
            const skillsQnaire = qnairesResult.Items.find(item =>
                item.op !== 'd' && item.isBaseQnaire === true && item.isActive === true && item.questionaireType === 'My Skills and Work Experience'
            );

            if (!skillsQnaire) {
                toast.error("Could not find the My Skills and Work Experience questionnaire");
                setLoading(false);
                return;
            }

            // Fetch user's questionnaire submissions
            const qnaireParams = {
                PK: `USER%23${cv._source.userid}`,
                SK: `USERQNAIRE%23`,
            };
            const qnaireResult = await fetchItemsWS('get-dynamodb', qnaireParams, getState);

            const skillsSubmissions = qnaireResult.Items.filter(item =>
                item.op !== 'd' && item.completionPercentage === 100 && item.questionaireId === skillsQnaire.id
            );

            // Get the latest submission
            const newestItem = skillsSubmissions.reduce((maxItem, currentItem) => {
                let maxDate = maxItem ? maxItem.createdAt.substring(0, 14) : '00000101T000000';
                let currentDate = currentItem.createdAt.substring(0, 14);
                return maxDate < currentDate ? currentItem : maxItem;
            }, null);

            if (!newestItem) {
                toast.error("No completed Skills questionnaire found for this user");
                setLoading(false);
                return;
            }

            // Fetch answers and questionnaire structure
            const userQnaireParams = {
                PK: `${newestItem.tenantId}%23USERQNAIRE%23${newestItem.id}`,
                SK: `ANSWER`
            };
            const QnaireParams = {
                PK: `${newestItem.tenantId}%23QNAIRE%23${skillsQnaire.id}`,
            };

            const answersResult = await fetchItemsWS('get-dynamodb', userQnaireParams, getState);
            const answers = answersResult.Items.filter(item => item.op !== 'd');
            dispatch({ type: FETCH_SELECTED_CV_ANSWERS_SUCCESS_ACTION, payload: answers });

            const qnaireStructResult = await fetchItemsWS('get-dynamodb', QnaireParams, getState);
            const qnaireItems = qnaireStructResult.Items.filter(item => item.op !== 'd');
            dispatch({ type: FETCH_SELECTED_CV_QNAIRE_SUCCESS_ACTION, payload: qnaireItems });

            setLoading(false);
        } catch (err) {
            console.log(err);
            dispatch({ type: FETCH_SELECTED_CV_ERROR_ACTION, err });
            setLoading(false);
        }
    };
}

export const FETCHING_SELECTED_CV_STATUS_ACTION = 'FETCHING_SELECTED_CV_STATUS_ACTION';
export const FETCH_SELECTED_CV_STATUS_SUCCESS_ACTION = 'FETCH_SELECTED_CV_STATUS_SUCCESS_ACTION';
export const FETCH_SELECTED_CV_STATUS_ERROR_ACTION = 'FETCH_SELECTED_CV_STATUS_ERROR_ACTION';

export const checkCVOwnStatusAction = (tenant, cv) => {
    const queryParams = {
        PK: `${tenant.id}%23BOUGHTCVS`,
        SK: `USER%23${cv._source.userid}`,

    };

    return (dispatch, getState) => {
        dispatch({ type: FETCHING_SELECTED_CV_STATUS_ACTION });
        fetchItemsWS('get-dynamodb', queryParams, getState)
            .then((result) => {
                let items = result.Items.filter((item) => item.op !== 'd');
                dispatch({ type: FETCH_SELECTED_CV_STATUS_SUCCESS_ACTION, payload: items });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: FETCH_SELECTED_CV_STATUS_ERROR_ACTION, err });
            });
    };
}
////////////////////////////////////////////////////////////////////////////////////////
//CV Search Log Actions
export const FETCHING_CVSEARCHLOG_ACTION = 'FETCHING_CVSEARCHLOG_ACTION';
export const FETCH_CVSEARCHLOG_SUCCESS_ACTION = 'FETCH_CVSEARCHLOG_SUCCESS_ACTION';
export const FETCH_CVSEARCHLOG_ERROR_ACTION = 'FETCH_CVSEARCHLOG_ERROR_ACTION';

export const fetchCVSearchLogsAction = (tenant) => {
    const queryParams = {
        PK: `${tenant.id}%23CVSEARCH`,
        SK: `CVSEARCH%23`
    };

    return (dispatch, getState) => {
        dispatch({ type: FETCHING_CVSEARCHLOG_ACTION });
        fetchItemsWS('get-dynamodb', queryParams, getState)
            .then((result) => {
                let items = result.Items.filter((item) => item.item.op !== 'd');
                dispatch({ type: FETCH_CVSEARCHLOG_SUCCESS_ACTION, payload: items });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: FETCH_CVSEARCHLOG_ERROR_ACTION, err });
            });
    };
}
////////////////////////////////////////////////////////////////////////////////////////
//Bought CVs Actions
export const FETCHING_BOUGHT_CVS_ACTION = 'FETCHING_BOUGHT_CVS_ACTION';
export const FETCH_BOUGHT_CVS_SUCCESS_ACTION = 'FETCH_BOUGHT_CVS_SUCCESS_ACTION';
export const FETCH_BOUGHT_CVS_ERROR_ACTION = 'FETCH_BOUGHT_CVS_ERROR_ACTION';

export const fetchBoughtCVsAction = (tenant) => {
    const queryParams = {
        PK: `${tenant.id}%23BOUGHTCVS`,
        SK: `USER%23`
    };

    return (dispatch, getState) => {
        dispatch({ type: FETCHING_BOUGHT_CVS_ACTION });
        fetchItemsWS('get-dynamodb', queryParams, getState)
            .then((result) => {
                let items = result.Items.filter((item) => item.item.op !== 'd');
                dispatch({ type: FETCH_BOUGHT_CVS_SUCCESS_ACTION, payload: items });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: FETCH_BOUGHT_CVS_ERROR_ACTION, err });
            });
    };
}

export const CLEAR_USER_CV = 'CLEAR_USER_CV';
export const clearUserCV = (dispatch) => {
    return (dispatch, getState) => {
        dispatch({ type: CLEAR_USER_CV })
    };
};

export const downloadCVFromSearchAction = (cv) => {
    return async (dispatch, getState) => {
        // Fetch base qnaires to find the active My Skills and My Profile questionnaires
        const qnaireListParams = {
            GSI2PK: `2WWjarbwyZ6IvJpoQKfzVWkGWiK%23QNAIRES`,
            GSI2SK: 'QNAIRE%23',
        };
        const qnairesResult = await fetchItemsWS('get-dynamodb', qnaireListParams, getState);
        const skillsQnaire = qnairesResult.Items.find(item =>
            item.op !== 'd' && item.isBaseQnaire === true && item.isActive === true && item.questionaireType === 'My Skills and Work Experience'
        );
        const profileQnaire = qnairesResult.Items.find(item =>
            item.op !== 'd' && item.isBaseQnaire === true && item.isActive === true && item.questionaireType === 'My Profile'
        );

        if (!skillsQnaire && !profileQnaire) {
            toast.error("Could not find the My Skills or My Profile questionnaire");
            return { userQnaire: null, userDoc: null };
        }

        const qnaireParams = {
            PK: `USER%23${cv._source.userid}`,
            SK: `USERQNAIRE%23`,
        };

        const qnaireResult = await fetchItemsWS('get-dynamodb', qnaireParams, getState);

        // Get all submissions for both types (include incomplete - docs may have been generated before completion updated)
        const skillsSubmissions = skillsQnaire ? qnaireResult.Items.filter(item =>
            item.op !== 'd' &&
            item.questionaireId === skillsQnaire.id
        ) : [];

        const profileSubmissions = profileQnaire ? qnaireResult.Items.filter(item =>
            item.op !== 'd' &&
            item.questionaireId === profileQnaire.id
        ) : [];

        const skillsSubmissionIds = skillsSubmissions.map(item => item.id);
        const profileSubmissionIds = profileSubmissions.map(item => item.id);

        const userDocsParams = {
            PK: `USER%23${cv._source.userid}`,
            SK: `DOCUMENT`,
        };

        const docsResult = await fetchItemsWS('get-dynamodb', userDocsParams, getState);

        // Combine all submission IDs from both types
        const allSubmissionIds = [...skillsSubmissionIds, ...profileSubmissionIds];

        // Get all documents linked to any skills or profile submission
        const allMatchingDocs = docsResult.Items
            .filter(item => allSubmissionIds.includes(item.userQuestionaireId))
            .sort((a, b) => (b.createdAt || '').localeCompare(a.createdAt || ''));

        // Among skills docs, prefer one with PDF, otherwise newest
        const skillsDocs = allMatchingDocs.filter(item => skillsSubmissionIds.includes(item.userQuestionaireId));
        // Among profile docs, prefer one with PDF, otherwise newest
        const profileDocs = allMatchingDocs.filter(item => profileSubmissionIds.includes(item.userQuestionaireId));

        // Pick best skills doc (PDF preferred), fall back to best profile doc
        const bestSkillsDoc = skillsDocs.find(doc => typeof doc.key === 'object' && doc.key.pdf) || skillsDocs[0] || null;
        const bestProfileDoc = profileDocs.find(doc => typeof doc.key === 'object' && doc.key.pdf) || profileDocs[0] || null;

        // Use skills doc if it exists, otherwise profile doc
        let matchingDocs = skillsDocs.length > 0 ? skillsDocs : profileDocs;
        let userDoc = skillsDocs.length > 0 ? bestSkillsDoc : bestProfileDoc;

        let filteredItems = skillsDocs.length > 0 ? skillsSubmissions : profileSubmissions;

        let userQnaire = filteredItems.reduce((maxItem, currentItem) => {
            let maxDate = maxItem ? maxItem.createdAt.substring(0, 14) : '00000101T000000';
            let currentDate = currentItem.createdAt.substring(0, 14);
            return maxDate < currentDate ? currentItem : maxItem;
        }, null);

        if (!userQnaire) return { userQnaire: null, userDoc: null };

        return { userQnaire, userDoc };
    };
};
